import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";

const steps = [
  {
    no: "01",
    icon: "ri-download-2-line",
    title: "收集原始素材",
    desc: "优先取得未经转发的原图、原视频与原始发布记录，记录获取路径与时间。",
  },
  {
    no: "02",
    icon: "ri-links-line",
    title: "交叉比对",
    desc: "将不同来源的素材在时间轴上对齐，找出能够相互印证或彼此矛盾的位置。",
  },
  {
    no: "03",
    icon: "ri-bar-chart-box-line",
    title: "依据分级",
    desc: "按可追溯性与独立性把每条依据标注为强、中、弱，不确定的明确标出。",
  },
  {
    no: "04",
    icon: "ri-percent-line",
    title: "给出可信度区间",
    desc: "综合证据强度输出可信度参考值，并说明哪些结论仍需要新依据支持。",
  },
];

export default function MethodSteps() {
  return (
    <section className="border-y border-background-300 bg-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-wide text-accent-300">
            <span className="h-px w-6 bg-accent-400" />
            核查方法
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            我们如何做真假辨析
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
            每一起事件都走同一套流程，把「感觉像真的」换成可以逐条核对的依据。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/15 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div key={step.no} className="bg-foreground-950 p-6">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                  <i className={`${step.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-background-50/15">
                  {step.no}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base font-semibold text-background-50">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <Link
            to="/method"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:border-accent-300 hover:text-accent-200 cursor-pointer"
          >
            查看完整分级标准 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}